import { render, staticRenderFns } from "./Pia.vue?vue&type=template&id=9d90ba4c&scoped=true"
import script from "./Pia.vue?vue&type=script&lang=js"
export * from "./Pia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d90ba4c",
  null
  
)

export default component.exports